import type {
  LivePosition,
  LiveMapState,
  MapInfo,
  PlannedPathPoint,
  SubscriptionStatus,
  TrailPoint,
} from './types/LiveMap.types';
import type { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import type { Optional } from 'lib/types/Optional';
import type {
  MapArea,
  MapFeatures,
  // eslint-disable-next-line max-len
} from 'app/modules/machine-inventory/machine-details-panel/components/MachineDetailsRobotPanel/MachineDetailsRobotSchedule/types/MapArea.types';

const selectLiveMapState = (state: IState): LiveMapState => state.modules['machine-inventory']['live-map'];

export const selectLiveMapStatus = (state: IState): LiveMapState['status'] => selectLiveMapState(state).status;

export const selectLiveMapMapInfo = (state: IState): Optional<MapInfo> => selectLiveMapState(state).mapInfo;

export const selectLiveMapImageUrl = (state: IState): Optional<string> => selectLiveMapState(state).mapImageUrl;

export const selectLiveMapPlannedPath = (state: IState): PlannedPathPoint[] => selectLiveMapState(state).plannedPath;

export const selectLiveMapTrail = (state: IState): TrailPoint[] => selectLiveMapState(state).trail;

export const selectLiveMapLivePosition = (state: IState): Optional<LivePosition> =>
  selectLiveMapState(state).livePosition;

export const selectLiveMapSubscriptionStatus = (state: IState): SubscriptionStatus =>
  selectLiveMapState(state).subscriptionStatus;

export const selectLiveMapCleaningZones = (state: IState): MapArea[] => selectLiveMapState(state).cleaningZones;

export const selectLiveMapCleaningZoneFeatures = (state: IState): Optional<MapFeatures> =>
  selectLiveMapState(state).cleaningZoneFeatures;

export const selectLiveMapActiveCleaningZoneIds = (state: IState): Optional<string[]> =>
  selectLiveMapState(state).activeCleaningZoneIds;

export const selectLiveMapError = (state: IState): Optional<unknown> => selectLiveMapState(state).error;
